import { Injectable } from '@angular/core';
import { AuthentificationService } from '@app/authentification/authentification.service';
import { HttpApiService } from '@app/providers/http-api/http-api.service';
import { forkJoin, Observable, of, catchError, map, switchMap, tap } from 'rxjs';
import { Dao } from '../dao';
import { DataLoaderAuthentified } from '../data-loader-authentified';

@Injectable({
  providedIn: 'root',
})
export class ParrainageDao extends Dao {
  private parrainages: DataLoaderAuthentified<any> =
    new DataLoaderAuthentified<any>(this.getAuthentified(), user => {
      return this.httpApi.get(`/accounts/${user.accountId}/parrainages`);
    });

  constructor(
    httpApi: HttpApiService,
    authentificationService: AuthentificationService,
  ) {
    super(httpApi, authentificationService);
  }

  /* Parrainages */
  getParrainages(): Observable<any> {
    return this.parrainages.get();
  }

  saveParrainage(entity: any): Observable<any> {
    let dto = { ...entity };
    delete dto.accountId;
    return this.command(user =>
      this.httpApi.post(`/accounts/${user.accountId}/parrainages`, dto),
    ).pipe(tap(() => this?.reset()));
  }

  searchSponsors(email: string): Observable<any> {
    return this.command(user =>
      this.httpApi.post(
        `/accounts/search-for-sponsporship/${user.organizationId}`,
        {
          login: email,
        },
      ),
    ).pipe(
      switchMap((response: any) => {
        const accounts = Array.isArray(response)
          ? response
          : response?.content || [];

        if (!accounts || accounts.length === 0) {
          return of([]);
        }
        const accountsWithIban = accounts.map(account => {
          const sponsor = {
            id: account.id,
            firstName: account.firstName,
            lastName: account.lastName,
            login: account.mainUserAccount?.login,
          };
          return this.httpApi.get(`/accounts/${account.id}/ownerIban`).pipe(
            map(iban => ({ ...sponsor, iban })),
            catchError(() => of({ ...sponsor, iban: null })),
          );
        });
        return accountsWithIban.length > 0
          ? forkJoin(accountsWithIban)
          : of([]);
      }),
    );
  }

  /* state */
  onUserChange(event: any) {
    this.parrainages?.reset();
  }

  reset() {
    this.parrainages?.reset();
  }
}
